export default __webpack_public_path__ + "static/media/THALES.50cdf370.png";